import React from 'react';

/**
 * AED Currency Icon Component
 * 
 * Custom AED (UAE Dirham) symbol icon matching Rashii brand.
 * Replaces generic $ dollar sign throughout the app.
 * 
 * Props:
 * - className: Standard className for sizing and colors
 * - size: Optional preset size (sm, md, lg)
 */
const AEDIcon = ({ className = "w-4 h-4", size, ...props }) => {
  // Size presets
  const sizeClasses = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };

  const finalClassName = size ? `${sizeClasses[size]} ${className.replace(/w-\d+\s*h-\d+/g, '')}` : className;

  return (
    <svg 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={finalClassName}
      {...props}
    >
      {/* AED Symbol - Stylized D with double stroke */}
      <path
        d="M25 15 
           C15 15 10 25 10 35
           L10 65
           C10 75 15 85 25 85
           L60 85
           C80 85 90 70 90 50
           C90 30 80 15 60 15
           L25 15
           Z
           M30 25
           L55 25
           C70 25 78 35 78 50
           C78 65 70 75 55 75
           L30 75
           L30 25
           Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      {/* Double horizontal strokes */}
      <rect x="5" y="38" width="40" height="6" rx="2" fill="currentColor" />
      <rect x="5" y="56" width="40" height="6" rx="2" fill="currentColor" />
    </svg>
  );
};

/**
 * Alternative: Image-based AED icon
 * Use this if you prefer the exact uploaded symbol
 */
export const AEDImageIcon = ({ className = "w-4 h-4", style = {}, ...props }) => {
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_d0108151-3ae9-48fb-99e7-9a583c6f4190/artifacts/qtukzm88_aed-symbol.png"
      alt="AED"
      className={`inline-block object-contain ${className}`}
      style={{ 
        filter: 'brightness(0) saturate(100%)',
        ...style 
      }}
      {...props}
    />
  );
};

export default AEDIcon;
